import styled from 'styled-components';
import { Text } from 'grommet';

export default styled(Text)`
  font-family: 'Turret Road', cursive;
`;
